module.exports = __webpack_public_path__ + "img/image-site-ai2p.f86c96d0.jpg";